import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconH3$1 = /*@__PURE__*/ proxyCustomElement(class WppIconH3 extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-h3", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.5 4.5C3.5 4.08579 3.16421 3.75 2.75 3.75C2.33579 3.75 2 4.08579 2 4.5V15.5C2 15.9142 2.33579 16.25 2.75 16.25C3.16421 16.25 3.5 15.9142 3.5 15.5V10.5H8.5V15.5C8.5 15.9142 8.83579 16.25 9.25 16.25C9.66421 16.25 10 15.9142 10 15.5V4.5C10 4.08579 9.66421 3.75 9.25 3.75C8.83579 3.75 8.5 4.08579 8.5 4.5V9H3.5V4.5ZM12.4705 6.4584C12.556 6.16283 12.6861 5.88533 12.9374 5.67386C13.1816 5.46843 13.6304 5.25 14.5 5.25C15.2766 5.25 15.7572 5.54931 16.055 5.89753C16.3749 6.27174 16.5 6.72336 16.5 7C16.5 7.35558 16.4086 7.92089 16.0525 8.38058C15.725 8.80344 15.0868 9.25 13.75 9.25C13.3358 9.25 13 9.58579 13 10C13 10.4142 13.3358 10.75 13.75 10.75C14.1956 10.75 14.9478 10.8604 15.5596 11.1694C16.1509 11.4681 16.5 11.8811 16.5 12.5C16.5 13.3393 16.2416 13.8852 15.9072 14.2197C15.569 14.5578 15.0833 14.75 14.5 14.75C13.8192 14.75 13.348 14.6341 13.0421 14.4506C12.7673 14.2858 12.572 14.0358 12.4854 13.6029C12.4042 13.1967 12.0091 12.9333 11.6029 13.0146C11.1968 13.0958 10.9333 13.4909 11.0146 13.8971C11.178 14.7142 11.6077 15.3392 12.2704 15.7369C12.9021 16.1159 13.6808 16.25 14.5 16.25C15.4168 16.25 16.306 15.9422 16.9678 15.2803C17.6334 14.6148 18 13.6607 18 12.5C18 11.2656 17.3046 10.4659 16.5189 9.98768C16.8023 9.78699 17.0407 9.55432 17.2384 9.29911C17.8687 8.48536 18 7.55067 18 7C18 6.37039 17.7501 5.57201 17.1951 4.92278C16.6178 4.24757 15.7234 3.75 14.5 3.75C13.3697 3.75 12.5495 4.0399 11.9717 4.52614C11.401 5.00634 11.1562 5.60383 11.0295 6.0416C10.9145 6.4395 11.1437 6.85537 11.5416 6.97046C11.9395 7.08556 12.3554 6.8563 12.4705 6.4584Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-h3-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-h3", "wpp-icon-h3-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-h3-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-h3-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconH3$1);
      }
      break;
  } });
}

const WppIconH3 = WppIconH3$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconH3, defineCustomElement };
